import React, { Component } from 'react';
import { Route } from 'react-router';
import { Layout } from './components/Layout';
import { Home } from './components/Home';
import { Counter } from './components/Counter';
import { FirstModel } from './components/FirstModel';
import { SecondModel } from './components/SecondModel';
import { ThirdModel } from './components/ThirdModel';
import { ForthModel } from './components/ForthModel';


export default class App extends Component {
  displayName = App.name

  render() {
    return (
      <Layout>
        <Route exact path='/' component={Home} />
        <Route path='/first' component={FirstModel} />
        <Route path='/second' component={SecondModel} />
        <Route path='/third' component={ThirdModel} />
        <Route path='/forth' component={ForthModel} />
      </Layout>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App.js